
import { contentCategoryEnum } from 'pawpaddock-common/data/content'

export default {
  name: 'NewsList',

  props: {
    gridClass: {
      type: String,
      default: 'grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'
    },

    newsLinkPrefix: {
      type: String,
      default: '/'
    }
  },

  data() {
    return {
      fetchNewsApi: new this.$ApiModel()
    }
  },

  computed: {
    compNews() {
      return this.fetchNewsApi.response.data || []
    }
  },

  created() {
    this.fetchNews()
  },

  methods: {
    async fetchNews() {
      await this.$api.content(this.fetchNewsApi).getAllPublishedContent(contentCategoryEnum.NEWS)
    }
  }
}
